import { render, staticRenderFns } from "./ClientModalForm.vue?vue&type=template&id=3f0e4737&scoped=true&"
import script from "./ClientModalForm.vue?vue&type=script&lang=js&"
export * from "./ClientModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e4737",
  null
  
)

export default component.exports